import React from 'react';

const WebDevelopment = () => {
    return (
        <div>
            <h1>Web Development page</h1>
        </div>
    );
}

export default WebDevelopment;
